export { ContentSectionImageTiles } from "./component-content-section-image-tiles";
export type { ImageTileItem } from "./interface";
